<script setup lang="ts">
import { isMobileView } from '../../../utils/helpers.ts';
interface ProductCardProps {
	brandName?: string;
	shopifyId?: number;
	price?: string;
	thumbnail?: string;
	currencySymbol?: string;
}

const props = defineProps<ProductCardProps>();
</script>
<template>
	<div
		class="flex flex-col video_card w-full rounded-medium"
		data-testid="video-card"
		:class="{ 'rounded-xl': isMobileView() }"
	>
		<div class="video-box aspect-[9/16] w-full rounded relative p-0">
			<slot name="video"> Video</slot>

			<div class="right-none top-none p-md absolute bg-transparent">
				<slot name="top-right"> </slot>
			</div>
			<div
				class="left-none top-none p-3xl absolute bg-transparent"
				:class="{ '!p-xl': isMobileView() }"
			>
				<slot name="top-left"> </slot>
			</div>
			<div class="right-none p-md bottom-none absolute bg-transparent">
				<slot name="bottom-right"> </slot>
			</div>
			<div
				v-if="$slots['bottom-left']"
				class="left-none bottom-none absolute bg-transparent"
			>
				<slot name="bottom-left"> </slot>
			</div>

			<div
				class="absolute top-1/2 w-full h-1/2 bg-gradient-to-t from-black/100 via-black/50 to-transparent rounded-b-xl opacity-60"
			></div>

			<div
				class="w-full grow p-3xl gap-xs flex flex-col absolute bottom-0"
				:class="{ 'p-xl': isMobileView() }"
			>
				<!-- Brand -  Info -->
				<div class="gap-xxs flex-nowrap flex items-start truncate flex-col">
					<p
						class="text-sm text-white font-normal"
						:class="{ 'text-xs': isMobileView() }"
					>
						{{ props.brandName }}
					</p>
					<p
						class="text-md text-white font-semibold"
						:class="{ 'text-sm': isMobileView() }"
					>
						{{ currencySymbol }} {{ props.price }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
